import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const protocol = {
  name: 'protocol',
  schemaType: STRING_SCHEMA_TYPE,
  method(protocols = ['https'], message) {
    const allowed = Array.isArray(protocols) ? protocols : [protocols]
    const defaultMessage = `A URL deve utilizar o protocolo ${allowed.join(
      ' ou ',
    )}`

    return this.test(
      'protocol',
      message ?? defaultMessage,
      (value) =>
        !value || allowed.some((item) => value.startsWith(`${item}://`)),
    )
  },
}

export default protocol
